import { PermissionMassiveOption } from '../keys/permissionMassive.interface';
import { PermissionOption } from '../models/permissionOption.interface';

export const PermissionMassive: PermissionOption[] = [
  { code: 'PXXX', option: PermissionMassiveOption.MASSIVE_COMMON_LOGIN, permissions: ['massive.common.login'] },
];
